import React, { useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";

const repeatOptions = [
	{ value: "never", label: "Never" },
	{ value: "daily", label: "Daily" },
	{ value: "weekly", label: "Weekly" },
	{ value: "monthly", label: "Monthly" },
	{ value: "yearly", label: "Yearly" },
];

const RepeatDropdown = ({ value, onChange, isOpen, setIsOpen }) => {
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [setIsOpen]);

	const selectedOption =
		repeatOptions.find((opt) => opt.value === value) || repeatOptions[0];

	return (
		<div className="relative w-full" ref={dropdownRef}>
			<button
				type="button"
				onClick={() => setIsOpen(!isOpen)}
				className="w-full flex items-center justify-between px-3 py-2 hover:bg-gray-100/50 dark:hover:bg-gray-800/50 rounded-lg text-sm text-gray-600 dark:text-gray-300"
			>
				<span>Repeat</span>
				<div className="flex items-center gap-2">
					<span>{selectedOption.label}</span>
					<ChevronDown className="w-4 h-4 text-gray-500 dark:text-gray-400 shrink-0" />
				</div>
			</button>

			{isOpen && (
				<div className="absolute z-50 mt-1 w-full rounded-md bg-white dark:bg-gray-800 py-1 shadow-lg ring-1 ring-black ring-opacity-5">
					{repeatOptions.map((option) => (
						<div
							key={option.value}
							onClick={() => {
								onChange(option.value);
								setIsOpen(false);
							}}
							className={`cursor-pointer px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700
                ${
									value === option.value
										? "bg-blue-50 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400"
										: "text-gray-900 dark:text-gray-100"
								}`}
						>
							{option.label}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default RepeatDropdown;
